const COMPANY_STATUSES = {
    INCOMPLETE: 'incomplete',
    PENDING: 'pending',
    PENDING_DOCUMENTS: 'pending_documents',
    PENDING_DOCUMENTS_VERIFICATION: 'pending_documents_verification',
};

export default COMPANY_STATUSES;
